import { ref as storageRef, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { projectStorage } from '@/firebase/config';

/**
 * Simplified storage operations
 */
const useStorage = () => {
  /**
   * Upload image and get download URL
   */
  const uploadImage = async (storagePath, imageFile) => {
    try {
      const imageRef = storageRef(projectStorage, storagePath);
      await uploadBytes(imageRef, imageFile);
      return await getDownloadURL(imageRef);
    } catch (error) {
      console.error('Error uploading image:', error);
      return null;
    }
  };

  /**
   * Delete image from storage
   */
  const removeImage = async (storagePath) => {
    try {
      const imageRef = storageRef(projectStorage, storagePath);
      await deleteObject(imageRef);
      return true;
    } catch (error) {
      // Don't treat missing files as errors
      if (error.code === 'storage/object-not-found') {
        return true;
      }
      console.error('Error deleting image:', error);
      return false;
    }
  };

  return { uploadImage, removeImage };
};

export default useStorage;
